// Stripe Public Key
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_KEY;